import { RemoteHandleProfessionalReport } from 'data/usecases';
import { HandleProfessionalReport } from 'domain/usecases';
import { makeApiUrlProfessionalReport } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleProfessionalReport = (): HandleProfessionalReport =>
  new RemoteHandleProfessionalReport(
    makeApiUrlProfessionalReport(),
    makeAxiosHttpClient(),
  );
